export const STATE_NAME = "contact";
export const FORM_NAME = STATE_NAME;
export const SUBMISSION_FORM_NAME = "contactSubmission";
